import React from 'react';
import { AlertOctagon, Phone } from 'lucide-react';
import { useStore } from '../../hooks/useStore';
import Container from '../../components/layout/Container';
import Card from '../../components/common/Card';

// Tela "Serviço temporariamente indisponível" exibida quando a loja está
// com isBlocked=true (Seção 2.3.6 do documento). É renderizada antes de
// qualquer rota interna do whitelabel.
const StoreUnavailablePage = () => {
  const { store } = useStore();

  return (
    <Container>
      <div className="min-h-[60vh] flex items-center justify-center py-16">
        <Card className="max-w-lg w-full p-8 text-center">
          {store?.logoUrl && (
            <img
              src={store.logoUrl}
              alt={store.name}
              className="h-16 mx-auto mb-4 object-contain"
            />
          )}
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-warning/10 text-warning mb-4">
            <AlertOctagon size={32} />
          </div>
          <h1 className="text-2xl font-extrabold text-app-text mb-2">
            Serviço temporariamente indisponível
          </h1>
          <p className="text-app-text-secondary mb-6">
            {store?.name ? `A loja ${store.name} está` : 'Esta loja está'}{' '}
            temporariamente fora do ar. Voltamos em breve.
          </p>
          {store?.supportPhone && (
            <div className="inline-flex items-center gap-2 text-sm text-app-text border border-app-border rounded-full px-4 py-2">
              <Phone size={14} className="text-primary" />
              <span>Suporte:</span>
              <a href={`tel:${store.supportPhone}`} className="font-semibold hover:underline">
                {store.supportPhone}
              </a>
            </div>
          )}
        </Card>
      </div>
    </Container>
  );
};

export default StoreUnavailablePage;
